export enum RouterQueries {
  ShowMockVideo = 'showMockVideo',
  SessionId = 'sessionId',
  Role = 'role',
  PatientId = 'patientId',
  Referrer = 'referrer',
}
